// Shell and library copy from ui/leshabank-frontend. Existing chat and editor copy
// stays in its original dictionaries.
export const V2_ENGLISH = {
  "datox.v2.table.details": "Technical details",
  "datox.v2.table.wrap": "Wrap text",
  "datox.v2.table.value": "Cell value",
  "datox.v2.table.cell": "Row {{row}}, {{column}}",
  "datox.v2.nav": "Navigation",
  "datox.v2.nav.reports": "Reports",
  "datox.v2.nav.templates": "Templates",
  "datox.v2.nav.agents": "Agents",
  "datox.v2.nav.preparation": "Preparation and operations",
  "datox.v2.nav.configuration": "Configuration",
  "datox.v2.nav.toolsShow": "Show workspace tools",
  "datox.v2.nav.toolsHide": "Hide workspace tools",
  "datox.v2.nav.reporting": "Reporting",
  "datox.v2.nav.outputsGroup": "Outputs and review",
  "datox.v2.nav.reportFiles": "Report files",
  "datox.v2.nav.collapse": "Collapse sidebar",
  "datox.v2.nav.expand": "Expand sidebar",
  "datox.v2.home.new": "New",
  "datox.v2.home.notClient": "Not client-specific",
  "datox.v2.home.retry": "Try again",
  "datox.v2.home.noMatch": "Nothing matches this search.",
  "datox.v2.home.filters": "Filters",
  "datox.v2.home.clearFilters": "Clear all",
  "datox.v2.home.filter.client": "Client",
  "datox.v2.home.filter.type": "Type",
  "datox.v2.home.period": "Period",
  "datox.v2.home.allPeriods": "All periods",
  "datox.v2.home.clearClient": "Show all clients",
  "datox.v2.reports.searchLabel": "Search reports and clients",
  "datox.v2.reports.searchPlaceholder": "Report, client or code",
  "datox.v2.reports.type.factsheet": "Factsheet",
  "datox.v2.reports.type.custom": "Custom report",
  "datox.v2.reports.type.history": "Earlier report",
  "datox.v2.reports.filter.status": "Status",
  "datox.v2.reports.updated": "Updated {{when}}",
  "datox.v2.reports.loading": "Loading reports…",
  "datox.v2.reports.error": "Reports could not be loaded.",
  "datox.v2.reports.empty": "No reports yet.",
  "datox.v2.reports.dataTo": "Data to {{date}}",
  "datox.v2.reports.older": "Older data",
  "datox.v2.reports.searchKeys": "Enter opens the first report, ↓ moves to the results",
  "datox.v2.title.reports": "Reports — Lesha Bank",
  "datox.v2.title.app": "Lesha Bank",
  "datox.v2.title.page": "{{page}} — Lesha Bank",
  "datox.v2.login.title": "Sign in to Lesha Bank",
  "datox.v2.login.description": "Sign in with your company Microsoft account to continue to Lesha Bank.",
} as const
